import {HttpClient} from '@angular/common/http';
import {AppConfig} from '../../app.config';
import {Injectable} from '@angular/core';

@Injectable()
export class MailTemplateService {
  constructor(private http: HttpClient, private api: AppConfig) {}

  getMailTemplate (platformId) {
    return this.http.get(this.api.baseUrl + '/mailTemplate/findTemplate?platformId=' + platformId,
      this.api.jsonTokenHeaders);
  }
}
